import { observer } from "mobx-react-lite";
import { ContextProps, Link, NavItem } from "@menu/core/types";
import { AnalyticsType, getAnalyticTags, getDataTitleTag } from "@menu/core/lib";
import { useOpenLink } from "@menu/core/hooks";

type MobileSubNavProps = ContextProps & {
    onBack?: any,
    selectedItem?: NavItem | null,
}

const MobileSubNav = observer((props: MobileSubNavProps) => {
    const { onBack, selectedItem, context } = props;
    const openLink = useOpenLink(context);

    if (!context.displaySubMenu || !selectedItem?.subnavItems?.length) {
        return null;
    }

    const getAnalytics = (link: Link) => {
        return getAnalyticTags({
            component_name: "mobile_header",
            nav_item: AnalyticsType.menu,
            nav_text: `${selectedItem.title}:${link.title}`,
            target_page_url: link.link
        });
    }

    const onClick = (e: any, link: Link) => {
        openLink(e, link, context)
        context.updateDisplayMobileNav(false);
    }

    return (
        <nav className="mobile-sub-nav">
            <p className="mobile-back"
                onClick={() => onBack()}
                //Need analytics?
                {...getDataTitleTag(`Back ${selectedItem.title}`)}>
                <i className="icon-arrow-long-left_4px" />
                <label>
                    {selectedItem.title}
                </label>
            </p>

            <ul>
                {selectedItem.subnavItems.map((x, ix) =>
                    <li key={ix}
                        {...getAnalytics(x)}
                        {...getDataTitleTag(x.title)}
                        onClick={(e) => onClick(e, x)}>
                        {x.title}
                    </li>)}
            </ul>
        </nav>);
});

export default MobileSubNav;